import React from 'react'
import PropTypes from 'prop-types'

import { DescriptionWrapper } from './LayerDescription.styles'

function createMarkup(body) {
  return { __html: body }
}

const LayerDescription = ({ description, lang, opened }) => {
  return (
    <DescriptionWrapper opened={opened} lang={lang}>
      <div dangerouslySetInnerHTML={createMarkup(description[lang])} />
    </DescriptionWrapper>
  )
}

LayerDescription.propTypes = {
  description: PropTypes.object,
  lang: PropTypes.string,
  opened: PropTypes.bool
}

export default LayerDescription
